/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

const SETTING_BASE_LINK = '/admin/settings'

export function getCompanySettingsLink () {
  return `${SETTING_BASE_LINK}/company`
}

export function getTemplatesSettingsLink () {
  return `${SETTING_BASE_LINK}/templates`
}
